export default "__VITE_ASSET__ByjaVgnC__"